// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Nested submenu styles */
.nested-submenu {
  list-style: none;
  margin-top: 5px !important;
  padding: 8px 5px;
  border-radius: 0 0 8px 8px;
  background: #e9f2fa;
  animation: slideDown 0.3s ease;
}

.nested-submenu li a {
  font-weight: 500;
  color: #333;
  background: none;
  padding-left: 55px !important;
}

.nested-submenu li a:hover {
  background: transparent;
  color: #004996;
  transform: none;
}

.nested-submenu li.active a {
  box-shadow: none;
  background: transparent;
  color: #004996;
  font-weight: 600;
}
@media (max-width: 1024px) {
  .sidebar {
    display: none;
  }
}
.sidebar {
  width: clamp(280px, 20vw, 310px);
  height: -webkit-fill-available;
  background: #F8F8F8;
  color: rgb(12, 12, 12);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  top: 0;
  /* box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1); */
  transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);
  z-index: 1200;
}

.sidebar.closed {
  transform: translateX(-100%);
}

.sidebar.open {
  transform: translateX(0);
}

/* Slide main content when sidebar is open */
.main-wrapper {
  transition: margin-left 0.3s cubic-bezier(0.4,0,0.2,1);
  margin-left: 270px;
  min-height: 100vh;
  max-width: calc(100% - 270px);
  overflow-x: hidden;
  box-sizing: border-box;
}
.sidebar-closed.main-wrapper {
  margin-left: 0;
  max-width: 100%;
}

@media (max-width: 900px) {
  .main-wrapper {
    margin-left: 0;
    max-width: 100%;
  }
  .sidebar {
    z-index: 1300;
  }
}

.sidebar.closed {
  transform: translateX(-100%);
}

/* Mobile responsive behavior - sidebar closed by default on screens 600px and below */
@media (max-width: 900px) {
  .sidebar {
    transform: translateX(-100%);
  }

  .sidebar.open {
    transform: translateX(0%);
  }
}



.sidebar-header {
  margin-top: 20px;
  display: flex;
  justify-content: center;

  img{
    width: 50%;
  }
}

.sidebar-header h2 {
  margin: 0;
  font-weight: 600;
  color: rgb(9, 9, 9);
}

.sidebar-nav {
  flex: 1 1;
  padding: 20px 0;
  overflow-y: auto;
}

.sidebar-menu {
  list-style: none;
  margin-left: 20px;
  padding: 0;

  
}

.sidebar-menu li {
  margin: 10px 10px;

  @media(max-width: 767px){
    margin: 0px 5px;
  }

  
}

.sidebar-menu li a {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #898989;
  text-decoration: none;
  transition: all 0.3s ease;
  font-weight: 600;
  /* gap: 10px; */
}

.sidebar-menu li a:hover {
  background: #004996;
  transform: scale3d(1.05, 1.05, 1);
  color: #ffffff;
  border-radius: 12px;
}

.sidebar-menu li.active a {
  background: #004996;
  color: #ffffff;
  border-radius: 12px;
}

.sidebar-menu li a .icon {
  margin-right: 12px;
  width: 24px;
  height: 24px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}

.sidebar-menu li a .icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}

.sidebar-menu li a .label {
    position: relative;
  font-weight: 500;
}

.sidebar-menu li a .label.active {
  color: #ffffff;
  font-weight: 600;
}

/* .sidebar-menu li a .icon.active {
  filter: brightness(0) saturate(100%) invert(39%) sepia(58%) saturate(1677%) hue-rotate(360deg) brightness(92%) contrast(88%);
} */

/* .sidebar-menu li a .label:hover{
  color: #BA7953;
} */

/* Menu item wrapper for dropdowns */
.menu-item-wrapper {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #898989;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  gap: 10px;
  
}
.menu-item-wrapperr{
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #ffffff;
  cursor: pointer;
  transition: all 0.3s ease;
  font-weight: 500;
  gap: 10px;
}
.menu-item-wrapper:hover, .menu-item-wrapper:has( .open){
  color: #ffffff;
  font-weight: 500;
  background: #004996;
  border-radius: 12px;
}

.menu-item-wrapper.active {
  background: #004996;
  color: #ffffff;
}

.menu-item-wrapper .icon.active {
  color: #ffffff;
}

.menu-item-wrapper:hover .icon {
  color: #ffffff;
}

.menu-item-wrapper .icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.menu-item-wrapper .icon:hover{
  color: #ffffff;
}

.menu-item-wrapper .icon img {
  width: 30px;
  height: 30px;
  object-fit: contain;
}



.dropdown-arrow {
  margin-left: auto;
  transition: transform 0.3s ease;
}

.dropdown-arrow.open {
  transform: rotate(-180deg);
}

/* Submenu styles */
.submenu {
  list-style: none;
  margin-top: 10px;
  padding: 10px 5px;
  animation: slideDown 0.3s ease;
  border-radius: 12px;
  background: #004996;
}

@keyframes slideDown {
  from {
    opacity: 0;
    max-height: 0;
  }
  to {
    opacity: 1;
    max-height: 300px;
  }
}
 
.submenu li {
  margin-bottom: 0;
  color: #898989;
}

.submenu li a {
  /* padding: 10px 20px 10px 56px; */
  font-weight: 600;
  color: #ffffff;
  background: none;

}

.submenu li a:hover {
  background: #feffffe5;
  box-shadow: inset 4px 0 0 0 #f0f1f3;
  color: #004996;
}

.submenu li.active a {
  /* color: #BA7953; */
  box-shadow: inset 4px 0 0 0 #004996;
     background: #feffffe5;
   color: #004996;

}

.submenu li a .sublabel {
  font-weight: 450;
  
}

.submenu li a .sublabel.active {
  /* color: #BA7953; */
  /* font-weight: 600; */
}
.sidebar-footer-image{
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  padding: 12px 20px;
  gap: 10px;

  p{
    font-weight: 600;
  }
}
.bottom{
  margin-left: 20px;
}
.sidebar-footer {
  margin: 10px 10px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

.logout-btn {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: #898989;
  background: none;
  border: none;
  text-decoration: none;
  border-radius: 12px;
  transition: all 0.3s ease;
  width: 100%;
  cursor: pointer;
  font-family: inherit;
    font-weight: 500;
    gap: 10px;
}

.logout-btn:hover {
  background: #004996;
  color: #ffffff;
}

.logout-btn .icon {
  margin-right: 12px;
}



/* Scrollbar styling */
.sidebar-nav::-webkit-scrollbar {
  width: 6px;
}

.sidebar-nav::-webkit-scrollbar-track {
  background: rgba(255, 255, 255, 0.05);
}

.sidebar-nav::-webkit-scrollbar-thumb {
  background: rgba(255, 255, 255, 0.2);
  border-radius: 3px;
}

.sidebar-nav::-webkit-scrollbar-thumb:hover {
  background: rgba(255, 255, 255, 0.3);
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/sidebar.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,0BAA0B;EAC1B,gBAAgB;EAChB,0BAA0B;EAC1B,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE;IACE,aAAa;EACf;AACF;AACA;EACE,gCAAgC;EAChC,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,OAAO;EACP,MAAM;EACN,+CAA+C;EAC/C,oDAAoD;EACpD,aAAa;AACf;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,4CAA4C;AAC5C;EACE,sDAAsD;EACtD,kBAAkB;EAClB,iBAAiB;EACjB,6BAA6B;EAC7B,kBAAkB;EAClB,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;IACd,eAAe;EACjB;EACA;IACE,aAAa;EACf;AACF;;AAEA;EACE,4BAA4B;AAC9B;;AAEA,sFAAsF;AACtF;EACE;IACE,4BAA4B;EAC9B;;EAEA;IACE,yBAAyB;EAC3B;AACF;;;;AAIA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;;EAEvB;IACE,UAAU;EACZ;AACF;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,UAAU;;;AAGZ;;AAEA;EACE,iBAAiB;;EAEjB;IACE,eAAe;EACjB;;;AAGF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;IACI,kBAAkB;EACpB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;GAEG;;AAEH;;GAEG;;AAEH,oCAAoC;AACpC;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;;AAEX;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,SAAS;AACX;AACA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;;;AAIA;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,mBAAmB;AACnB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE;IACE,UAAU;IACV,aAAa;EACf;EACA;IACE,UAAU;IACV,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,gBAAgB;;AAElB;;AAEA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mCAAmC;KAChC,qBAAqB;GACvB,cAAc;;AAEjB;;AAEA;EACE,gBAAgB;;AAElB;;AAEA;EACE,oBAAoB;EACpB,sBAAsB;AACxB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;;EAET;IACE,gBAAgB;EAClB;AACF;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,oBAAoB;IAClB,gBAAgB;IAChB,SAAS;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;;;AAIA,sBAAsB;AACtB;EACE,UAAU;AACZ;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;AACtC","sourcesContent":["/* Nested submenu styles */\n.nested-submenu {\n  list-style: none;\n  margin-top: 5px !important;\n  padding: 8px 5px;\n  border-radius: 0 0 8px 8px;\n  background: #e9f2fa;\n  animation: slideDown 0.3s ease;\n}\n\n.nested-submenu li a {\n  font-weight: 500;\n  color: #333;\n  background: none;\n  padding-left: 55px !important;\n}\n\n.nested-submenu li a:hover {\n  background: transparent;\n  color: #004996;\n  transform: none;\n}\n\n.nested-submenu li.active a {\n  box-shadow: none;\n  background: transparent;\n  color: #004996;\n  font-weight: 600;\n}\n@media (max-width: 1024px) {\n  .sidebar {\n    display: none;\n  }\n}\n.sidebar {\n  width: clamp(280px, 20vw, 310px);\n  height: -webkit-fill-available;\n  background: #F8F8F8;\n  color: rgb(12, 12, 12);\n  display: flex;\n  flex-direction: column;\n  position: fixed;\n  left: 0;\n  top: 0;\n  /* box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1); */\n  transition: transform 0.3s cubic-bezier(0.4,0,0.2,1);\n  z-index: 1200;\n}\n\n.sidebar.closed {\n  transform: translateX(-100%);\n}\n\n.sidebar.open {\n  transform: translateX(0);\n}\n\n/* Slide main content when sidebar is open */\n.main-wrapper {\n  transition: margin-left 0.3s cubic-bezier(0.4,0,0.2,1);\n  margin-left: 270px;\n  min-height: 100vh;\n  max-width: calc(100% - 270px);\n  overflow-x: hidden;\n  box-sizing: border-box;\n}\n.sidebar-closed.main-wrapper {\n  margin-left: 0;\n  max-width: 100%;\n}\n\n@media (max-width: 900px) {\n  .main-wrapper {\n    margin-left: 0;\n    max-width: 100%;\n  }\n  .sidebar {\n    z-index: 1300;\n  }\n}\n\n.sidebar.closed {\n  transform: translateX(-100%);\n}\n\n/* Mobile responsive behavior - sidebar closed by default on screens 600px and below */\n@media (max-width: 900px) {\n  .sidebar {\n    transform: translateX(-100%);\n  }\n\n  .sidebar.open {\n    transform: translateX(0%);\n  }\n}\n\n\n\n.sidebar-header {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n\n  img{\n    width: 50%;\n  }\n}\n\n.sidebar-header h2 {\n  margin: 0;\n  font-weight: 600;\n  color: rgb(9, 9, 9);\n}\n\n.sidebar-nav {\n  flex: 1;\n  padding: 20px 0;\n  overflow-y: auto;\n}\n\n.sidebar-menu {\n  list-style: none;\n  margin-left: 20px;\n  padding: 0;\n\n  \n}\n\n.sidebar-menu li {\n  margin: 10px 10px;\n\n  @media(max-width: 767px){\n    margin: 0px 5px;\n  }\n\n  \n}\n\n.sidebar-menu li a {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  color: #898989;\n  text-decoration: none;\n  transition: all 0.3s ease;\n  font-weight: 600;\n  /* gap: 10px; */\n}\n\n.sidebar-menu li a:hover {\n  background: #004996;\n  transform: scale3d(1.05, 1.05, 1);\n  color: #ffffff;\n  border-radius: 12px;\n}\n\n.sidebar-menu li.active a {\n  background: #004996;\n  color: #ffffff;\n  border-radius: 12px;\n}\n\n.sidebar-menu li a .icon {\n  margin-right: 12px;\n  width: 24px;\n  height: 24px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.sidebar-menu li a .icon img {\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n}\n\n.sidebar-menu li a .label {\n    position: relative;\n  font-weight: 500;\n}\n\n.sidebar-menu li a .label.active {\n  color: #ffffff;\n  font-weight: 600;\n}\n\n/* .sidebar-menu li a .icon.active {\n  filter: brightness(0) saturate(100%) invert(39%) sepia(58%) saturate(1677%) hue-rotate(360deg) brightness(92%) contrast(88%);\n} */\n\n/* .sidebar-menu li a .label:hover{\n  color: #BA7953;\n} */\n\n/* Menu item wrapper for dropdowns */\n.menu-item-wrapper {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  color: #898989;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  gap: 10px;\n  \n}\n.menu-item-wrapperr{\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  color: #ffffff;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  font-weight: 500;\n  gap: 10px;\n}\n.menu-item-wrapper:hover, .menu-item-wrapper:has( .open){\n  color: #ffffff;\n  font-weight: 500;\n  background: #004996;\n  border-radius: 12px;\n}\n\n.menu-item-wrapper.active {\n  background: #004996;\n  color: #ffffff;\n}\n\n.menu-item-wrapper .icon.active {\n  color: #ffffff;\n}\n\n.menu-item-wrapper:hover .icon {\n  color: #ffffff;\n}\n\n.menu-item-wrapper .icon {\n  width: 24px;\n  height: 24px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n.menu-item-wrapper .icon:hover{\n  color: #ffffff;\n}\n\n.menu-item-wrapper .icon img {\n  width: 30px;\n  height: 30px;\n  object-fit: contain;\n}\n\n\n\n.dropdown-arrow {\n  margin-left: auto;\n  transition: transform 0.3s ease;\n}\n\n.dropdown-arrow.open {\n  transform: rotate(-180deg);\n}\n\n/* Submenu styles */\n.submenu {\n  list-style: none;\n  margin-top: 10px;\n  padding: 10px 5px;\n  animation: slideDown 0.3s ease;\n  border-radius: 12px;\n  background: #004996;\n}\n\n@keyframes slideDown {\n  from {\n    opacity: 0;\n    max-height: 0;\n  }\n  to {\n    opacity: 1;\n    max-height: 300px;\n  }\n}\n \n.submenu li {\n  margin-bottom: 0;\n  color: #898989;\n}\n\n.submenu li a {\n  /* padding: 10px 20px 10px 56px; */\n  font-weight: 600;\n  color: #ffffff;\n  background: none;\n\n}\n\n.submenu li a:hover {\n  background: #feffffe5;\n  box-shadow: inset 4px 0 0 0 #f0f1f3;\n  color: #004996;\n}\n\n.submenu li.active a {\n  /* color: #BA7953; */\n  box-shadow: inset 4px 0 0 0 #004996;\n     background: #feffffe5;\n   color: #004996;\n\n}\n\n.submenu li a .sublabel {\n  font-weight: 450;\n  \n}\n\n.submenu li a .sublabel.active {\n  /* color: #BA7953; */\n  /* font-weight: 600; */\n}\n.sidebar-footer-image{\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: flex-start;\n  padding: 12px 20px;\n  gap: 10px;\n\n  p{\n    font-weight: 600;\n  }\n}\n.bottom{\n  margin-left: 20px;\n}\n.sidebar-footer {\n  margin: 10px 10px;\n  border-top: 1px solid rgba(255, 255, 255, 0.1);\n}\n\n.logout-btn {\n  display: flex;\n  align-items: center;\n  padding: 12px 20px;\n  color: #898989;\n  background: none;\n  border: none;\n  text-decoration: none;\n  border-radius: 12px;\n  transition: all 0.3s ease;\n  width: 100%;\n  cursor: pointer;\n  font-family: inherit;\n    font-weight: 500;\n    gap: 10px;\n}\n\n.logout-btn:hover {\n  background: #004996;\n  color: #ffffff;\n}\n\n.logout-btn .icon {\n  margin-right: 12px;\n}\n\n\n\n/* Scrollbar styling */\n.sidebar-nav::-webkit-scrollbar {\n  width: 6px;\n}\n\n.sidebar-nav::-webkit-scrollbar-track {\n  background: rgba(255, 255, 255, 0.05);\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb {\n  background: rgba(255, 255, 255, 0.2);\n  border-radius: 3px;\n}\n\n.sidebar-nav::-webkit-scrollbar-thumb:hover {\n  background: rgba(255, 255, 255, 0.3);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
